import en from 'translations/en/popularProducts.json';
import pl from 'translations/pl/popularProducts.json';
import sl from 'translations/sl/popularProducts.json';
import { ITranslations } from 'types/common';
import { PopularProductsTransFields } from './types';

export const popularProductsTranslations: ITranslations<PopularProductsTransFields> = {
  name: 'popularProducts',
  en,
  pl,
  sl,
};
